import { DialogContent, Modal } from '@material-ui/core'
import * as React from 'react'
// TODO: fix this one looks broken
// @ts-ignore
import { SemipolarLoading } from 'react-loadingg'

interface Props {
    open: boolean
}

export const LoadingModal: React.FC<Props> = ({ open }) => {

    return (
        <Modal
            style={{
                padding: 30,
                backdropFilter: 'blur(3px)',
                backgroundColor: 'rgba(0,0,30,0.4)',
                width: '100%',
                height: '100%'
            }}
            open={open}
            keepMounted>
            <DialogContent>
                <div style={{ width: '100%', height: '100%' }}>
                    <SemipolarLoading />
                </div>
            </DialogContent>

        </Modal>
    )
}
